package frontend.pages

import androidx.compose.runtime.Composable
import frontend.lib.classList
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun LoaderUI() {
    Div(attrs = {
        classList("fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-800 flex flex-col items-center justify-center")
        attr("wire-loading", "true")
    }) {
        Div(attrs = {
            classList("loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4")
        })
        H2(attrs = {
            classList("text-center text-white text-xl font-semibold")
        }) {
            Text("Loading...")
        }
        P(attrs = {
            classList("w-1/3 text-center text-white")
        }) {
            Text("This may take a few seconds, please don't close this page.")
        }
    }
//    <div wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
//    <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
//    <h2 class="text-center text-white text-xl font-semibold">Loading...</h2>
//    <p class="w-1/3 text-center text-white">This may take a few seconds, please don't close this page.</p>
//    </div>
}